<div class="row pl-1 w-100">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <div class="col-12 not-found" *ngIf="project_list && project_list.length==0 ">
      <div class="boq-img text-center">
        <img src="../../../assets/img/desktop.png">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
    </div>
    <div class="col-12" *ngIf="project_list && project_list.length>0">
      <div class="tableDiv project-table">
        <table class="table">
          <thead class="ss-thead">
            <tr>
              <th class="firstTh">LEAD ID</th>
              <th>CLIENT NAME</th>
              <th> DESIGNER </th>
              <th> CM </th>
              <th> DATE OF RAISING REQ </th>
              <th> TIME REMAINING </th>
              <th> COUNT </th>
              <th class="lastTh">NEW</th>
            </tr>
          </thead>
          <tbody class="ss-tbody">
            <ng-container *ngFor="let obj of project_list | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page}; let i = index"
              [attr.data-index]="i">
              <tr (click)="getProjectDetails(obj.id,obj); updateCESeen(obj.id)">
                <td class="addCursor">
                  <span *ngIf="obj.lead_details">{{obj.lead_details.id}}</span>
                </td>
                <td class="capitalize addCursor">
                  <span *ngIf="obj.lead_details">{{ obj.lead_details.name }}</span>
                </td>
                <td class="capitalize addCursor">
                  <span *ngIf="obj.designer_details">{{obj.designer_details.name}}</span>
                </td>
                <td class="capitalize addCursor">
                  <span *ngIf="obj.cm_details">{{obj.cm_details.name}}</span>
                </td>
                <td class="capitalize addCursor">
                  <span *ngIf="obj.custom_element_request_date">{{obj.custom_element_request_date}}</span>
                </td>
                <td class="capitalize addCursor">{{obj.time_remaining}}</td>
                <td class="capitalize addCursor">{{obj.custom_element_count}}</td>
                <td class="capitalize addCursor new-{{obj.id}}" style="color: #89081c;font-weight: 600;">{{obj.new ? "New!" : ""}}</td>  
              </tr>
              <tr *ngIf="obj.expanded">
                <td colspan="10">
                  <div class= " d-inline-block pull-right pt-2 pr-4">
                    <button type="button" class="close close-project-row addCursor" aria-label="Close" (click)="toggleRow(obj)" style="outline: none">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-5 pr-4 d-inline-block pb-0">
                    <div class="card-parent-custom p-0 d-inline-block mr-2 ml-2 pb-0 pull-left Vcard" *ngFor="let obj of customList;let i = index" [attr.data-index]="i">
                      <div class="card pb-0 m-0 myCard" style="height: 560px !important">
                        <div class="ribbon ribbon-top-right pb-0 p-0">
                          <span class="pull-right" *ngIf="obj.photo != '/images/original/missing.png'">
                            <a href="{{obj.photo}}" download target="_blank">
                              <i class="fa fa-download dwnld download-icon" aria-hidden="true"></i>
                            </a>
                          </span>
                          <img *ngIf="obj.image_available == true" class="Vcard-img-top px-2 pt-2" src="{{ obj.photo }}" alt="Card image cap">
                          <img *ngIf="obj.photo == '/images/original/missing.png'" class="Vcard-img-top px-2 pt-2" src="/assets/img/no_image.svg" alt="Card image cap">
                          <img *ngIf="obj.image_available == false" class="Vcard-img-top px-2 pt-2" src="/assets/img/no_image.svg" alt="Card image cap">
                          <div class="card-body py-2">
                              <a data-trigger="hover" title="Name" [attr.data-content]="obj.name" class="pop col-xs-6 p-0 w-50 text-left" 
                              (mouseenter)="openpopup($event)">
                            <h6 class="capitalize hdng-chng text-left" 
                            style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.name }}
                            </h6></a>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Shutter Finish:</div>
                              <a data-trigger="hover" title="Shutter Finish" [attr.data-content]="obj.shutter_finish" class="pop col-xs-6 p-0 w-50 text-left" 
                              (mouseenter)="openpopup($event)">
                              <div class="p-0" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.shutter_finish }}</div></a>
                            </div>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Core Material:</div>
                              <a data-trigger="hover" title="Core Material" [attr.data-content]="obj.core_material" class="pop col-xs-6 p-0 w-50" 
                              (mouseenter)="openpopup($event)">
                              <div class="p-0 text-left" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.core_material }}</div></a>
                            </div>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Dimension:</div>
                              <a data-trigger="hover" title="Dimension" [attr.data-content]="obj.dimension" class="pop col-xs-6 p-0 w-50" 
                              (mouseenter)="openpopup($event)">
                              <div class="col-xs-6 p-0 w-50 text-left" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.dimension }}</div></a>
                            </div>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Remark:</div>
                              <a data-trigger="hover" title="Remark" [attr.data-content]="obj.designer_remark" class="pop col-xs-6 p-0 w-50" 
                              (mouseenter)="openpopup($event)">
                              <div class="p-0 text-left" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.designer_remark }}</div></a>
                            </div>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Price:</div>
                              <div class="col-xs-6 p-0 text-left">{{ obj.ask_price }}</div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.price">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">My Price:</div>
                              <div class="col-xs-6 p-0 text-left">{{ obj.price }}</div>
                            </div>
                            <div class="row m-0 p-0">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Cost Price:</div>
                              <div class="col-xs-6 p-0 text-left">{{ obj.cost_price }}</div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.category_remark">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">My Remark:</div>
                              <a data-trigger="hover" title="My Remark" [attr.data-content]="obj.category_remark" class="pop col-xs-6 p-0 w-50" 
                              (mouseenter)="openpopup($event)">
                              <div class="p-0 text-left" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{ obj.category_remark }}</div>
                              </a>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.timeline">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Time of Delivery:</div>
                              <div class="col-xs-6 p-0 text-left">{{ obj.timeline }} days</div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.status">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Status:</div>
                              <div class="p-0 text-left">{{ obj.status | replaceChar }}</div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.updated_at && (obj.status=='rejected'|| obj.status=='approved')">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Date Of Response:</div>
                              <div class="p-0 text-left">{{ obj.updated_at|date}}</div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.category_split">
                              <div class="col-xs-6 col-md-6 p-0 pr-2 font-weight-bold text-left">Type:</div>
                              <div class="p-0 text-left">{{ obj.category_split | replaceChar }}</div>
                            </div>
                            <!-- //////Buttons(this will appear according role) for category services role////// -->
                            <div class="row m-0 p-0" *ngIf="obj.status==='pending' && role=='category_services' && obj.category_split==='services'">
                              <div class="border-change text-center p-0 pb-0 mr-2">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#rejectModal" (click)="setDocId(obj.id,'rejected')">Reject</button>
                              </div>
                              <div class="border-change text-center pb-0 p-0" *ngIf="obj.category_split">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#approveModal" (click)="setDocId(obj.id,'approved')">Approve</button>
                              </div>
                            </div>
                             <!-- //////Buttons(this will appear according role) for category panel role////// -->
                            <div class="row m-0 p-0" *ngIf="obj.status==='pending' && role=='category_panel' && obj.category_split==='panel'">
                              <div class="border-change text-center p-0 pb-0 mr-2">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#rejectModal" (click)="setDocId(obj.id,'rejected')">Reject</button>
                              </div>
                              <div class="border-change text-center pb-0 p-0" *ngIf="obj.category_split">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#approveModal" (click)="setDocId(obj.id,'approved')">Approve</button>
                              </div>
                            </div>
                             <!-- //////Buttons(this will appear according role) for category non panel role////// -->
                            <div class="row m-0 p-0" *ngIf="obj.status==='pending' && role=='category_non_panel' && obj.category_split==='non_panel'">
                              <div class="border-change text-center p-0 pb-0 mr-2">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#rejectModal" (click)="setDocId(obj.id,'rejected')">Reject</button>
                              </div>
                              <div class="border-change text-center pb-0 p-0" *ngIf="obj.category_split">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#approveModal" (click)="setDocId(obj.id,'approved')">Approve</button>
                              </div>
                            </div>
                            <!-- //////Buttons(this will appear according role) for category head role////// -->
                            <div class="row m-0 p-0" *ngIf="obj.status==='pending' && role=='category_head'">
                              <div class="border-change text-center p-0 pb-0 mr-2">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#rejectModal" (click)="setDocId(obj.id,'rejected')">Reject</button>
                              </div>
                              <div class="border-change text-center pb-0 p-0" *ngIf="obj.category_split">
                                <button class="category-btn btn rounded btn2" data-toggle="modal" data-target="#approveModal" (click)="setDocId(obj.id,'approved')">Approve</button>
                              </div>
                            </div>
                            <!-- ///if category_split is equel to panel or other one.Then these thing will not show in option /// -->
                            <div class="row m-0 p-0" *ngIf="obj.status !='rejected'">
                              <div class="col-12 d-flex" *ngIf="(role=='category_panel' && obj.category_split=='panel')||(role=='category_non_panel' && obj.category_split=='non_panel')||(role=='category_services' && obj.category_split=='services')"> 
                                <div class="col-4 p-0 font-weight-bold text-left">Type<span style="color:#8c031f">&nbsp;*&nbsp;</span>:</div>
                                <div class="col-6 p-0">
                                  <select (change) = "selectSpace(obj.id, $event)" style="outline: none;">
                                    <option value="{{obj.category_split}}" selected>{{obj.category_split | replaceChar}}</option>
                                    <option value="panel"  *ngIf="obj.category_split !='panel'">Panel</option>
                                    <option value="non_panel" *ngIf="obj.category_split !='non_panel'">Non Panel</option>
                                    <option value="services" *ngIf="obj.category_split !='services'">Services</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="row m-0 p-0" *ngIf="obj.status !='rejected'&& role=='category_head'">
                            <div class="col-4 p-0 font-weight-bold text-left">Type<span style="color:#8c031f">&nbsp;*&nbsp;</span>:</div>
                              <div class="col-6 p-0">
                                <select (change) = "selectSpace(obj.id, $event)" style="outline: none;">
                                  <option value="{{obj.category_split}}" selected>{{obj.category_split | replaceChar}}</option>
                                  <option value="panel"  *ngIf="obj.category_split !='panel'">Panel</option>
                                  <option value="non_panel" *ngIf="obj.category_split !='non_panel'">Non Panel</option>
                                  <option value="services" *ngIf="obj.category_split !='services'">Services</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-5 pr-4 d-inline-block not-found " *ngIf="customList && customList.length==0 ">
                      <div class="boq-img mx-auto">
                        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
                      </div>
                      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
          </table>
          <div class="text-center" *ngIf="project_list && project_list.length >0">
            <pagination-controls autoHide="true" (pageChange)="current_page = getProjectList($event)"></pagination-controls>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="modal fade" id="approveModal" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 text-right">
            <button type="button" class="close pull-right addCursor" data-dismiss="modal" style="height: 38px;"
            (click)="closeModals()">&times;</button>
          </div>
        </div>
        <div class="modal-body mb-5">
            <div class="row pb-0">
                <div class="col-12 pb-0">
                  <form [formGroup]="priceForm">
                    <div class="row m-0 p-0 pl-5 pr-5">
                      <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">My Price:<span class="text-danger">*</span></div>
                      <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                        <input type="number" class="mb-2 form-control" placeholder="Price" formControlName="price" name="price">
                        <div *ngIf="priceErroralert" class="text-danger">
                                <div [hidden]="priceForm.controls['price'].valid">Enter valid price.</div>
                              </div>  
                            </div>
                          </div>
                         <!--Cost Price Data--> 
                          <div class="row m-0 p-0 pl-5 pr-5">
                            <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">Cost Price:<span class="text-danger">*</span></div>
                            <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                              <input type="number" class="mb-2 form-control" placeholder="Cost Price" formControlName="cost_price" name="price">
                              <div *ngIf="priceErroralert" class="text-danger">
                                      <div [hidden]="priceForm.controls['price'].valid">Enter Cost price.</div>
                          </div>  
                      </div>
                    </div>
                    <div class="row m-0 p-0 pl-5 pr-5">
                      <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">My Time of Delivery:<span class="text-danger">*</span></div>
                      <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                        <input type="number" class="mb-2 form-control" placeholder="Time of Delivery in days" formControlName="timeline" name="timeline">
                      </div>
                    </div>
                    <div class="row m-0 p-0 pl-5 pr-5">
                      <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">My Remark:</div>
                      <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                        <textarea type="text" class="form-control" placeholder="Remarks..." formControlName="category_remark" rows="4"></textarea>
                      </div>
                    </div>
                    <div class="border-change text-center pb-0 mt-4">
                      <button class="category-btn p-2 btn rounded" type="submit" (click)="onSubmit()">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
<div class="modal fade" id="rejectModal" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col-12 text-right">
              <button type="button" class="close pull-right addCursor" data-dismiss="modal" style="height: 38px;"
              (click)="closeModals()">&times;</button>
            </div>
          </div>
          <div class="modal-body mb-5">
              <div class="row pb-0">
                  <div class="col-12 pb-0">
                    <form [formGroup]="rejectForm">
                      <div class="row m-0 p-0 pl-5 pr-5">
                        <div class="col-xs-6 col-md-6 p-0 pr-2 pt-2 text-left">My Remark:</div>
                        <div class="col-xs-6 col-md-6 p-0 d-inline-block pull-right">
                          <textarea type="text" class="form-control" placeholder="Remarks..." formControlName="category_remark" rows="4"></textarea>
                        </div>
                      </div>
                      <div class="border-change text-center pb-0 mt-4">
                        <button class="category-btn p-2 btn rounded" type="submit" (click)="onSubmit()">Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
          </div>
        </div>
      </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/category/category/custom-element-approvals/custom-element-approvals.component.html